<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import CustomModal from "@/components/CustomModal/CustomModal.vue";
import CustomButton from "@/components/Button/Button.vue";

const { t } = useI18n();

const props = defineProps({
    uuid: String
});

const crewList = ref([]);

// Simulated fetch function; replace with actual API call or fetching logic
function fetchCrewData(uuid) {
    return {
        uuid: uuid,
        name: 'test',
        email: 'test@test.com',
        phone: '1234567890',
        address: '123 Test St',
        isActive: true,
        nationality: 'Testland',
        dateOfBirth: '01/01/1980',
        passportNumber: 'A12345678',
        passportExpiry: '01/01/2030',
        sailingLicense: 'SL123456',
    };
}

onMounted(() => {
    if (props.uuid) {
        const data = fetchCrewData(props.uuid);
        crewList.value.push(data);
    }
});

const showAddNewCrewList = ref(false);
</script>
<template>
    <div class="flex flex-col gap-8 py-12">
        <div class="flex justify-between align-center">
            <div class="flex gap-1 responsive-title-3 font-semibold header">
                <img src="@/assets/icons/svg/chevron.svg" alt="Crew">
                <div>{{ crewList[0]?.name || 'test' }}</div>
            </div>
            <div class="px-5" v-if="crewList[0] && crewList[0].members.length !== 0">
                <CustomButton type="black" class="self-end  responsive-body-medium w-fit h-8" :rounded="true"
                    @click="showAddNewCrewList = true">{{ $t('crewDetails.addNewMember') }}
                </CustomButton>
            </div>
        </div>
        <div class="flex justify-center items-center h-full gap-5 min-h-[400px] alignBoxClass">
            <div class="flex flex-col bg-background-light boxClass justify-between rounded-8xl p-5 pr-16">
                <div>
                    <img src="@/assets/icons/svg/Crew_40x40.svg" alt="Crew">
                </div>
                <div class=" responsive-body-large font-semibold">{{ $t('crewDetails.noCrewMember') }}</div>
            </div>
            <div @click="showAddNewCrewList = true"
                class="flex flex-col bg-primary-blue text-white justify-center items-center rounded-8xl p-12 gap-1 cursor-pointer boxClass"
                type="primary">
                <img src="@/assets/icons/svg/Add_24x24_white.svg" alt="Plus" width="44" />
                <div class=" responsive-body-large font-semibold text-center">{{ $t('crewDetails.addNewMember') }}</div>
            </div>
        </div>
    </div>
    <CustomModal :show="showAddNewCrewList" classes="w-1/6 ">
        <div class="flex flex-col p-6 ">
            <div class="cursor-pointer self-end " type="default" @click="showAddNewCrewList = false">
                <img src="@/assets/icons/svg/Close_16x16.svg" alt="Close" width="18" />
            </div>
            <div class="flex flex-col gap-2 px-9 py-7.5 min-w-[350px]">
                <div class="flex flex-col gap-6">
                    <div class=" responsive-body-large font-semibold">{{ $t('crewDetails.createNewList') }}</div>
                </div>
                <div class="flex flex-col">
                    <VTextField :label="$t('crewDetails.listNamePlaceholder')" type="name" variant="underlined">
                    </VTextField>
                </div>
                <div class="flex justify-between align-center">
                    <CustomButton type="black" class="self-start  responsive-body-medium w-25 h-13" :rounded="true"
                        @click="onBook">{{ $t('crewDetails.createButton') }}
                    </CustomButton>
                </div>
            </div>
        </div>
    </CustomModal>
</template>
